<div class="chat-link-block chat-link-block--pending" *ngIf="isPending">
  <div class="chat-link-block__thinking">
    <div class="chat-link-block__spinner">
      <span class="chat-link-block__dot"></span>
      <span class="chat-link-block__dot"></span>
      <span class="chat-link-block__dot"></span>
    </div>
    <span class="chat-link-block__thinking-label">Проверка...</span>
  </div>
</div>

<div class="chat-link-block" *ngIf="isReady">
  <button class="chat-link-block__bubble" type="button" (click)="navigate()">
    <span class="chat-link-block__label">{{ message?.payload?.label }}</span>
    <span class="chat-link-block__route">{{ route }}</span>
  </button>
</div>
